import moment from "moment";
import {
  CartesianGrid,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Bar,
  ComposedChart,
  ReferenceLine,
} from "recharts";

const mapData = (data, targetValue) => ({
  date: moment(String(data.utcDate)).format("MMM D"),
  value: data[targetValue],
});

// In this function we remove / sum the repeated dates
// this is necessary because if not, the chart doesn't show the data
const removeRepeated = (chartData) => {
  const filteredData = chartData.reduce((chartDataAcc, current) => {
    // find the index of the repeated element in the accumulator

    const existingElementIdx = chartDataAcc.findIndex(
      (element) => element.date === current.date
    );

    // if exists, sum the values
    if (existingElementIdx > 0) {
      chartDataAcc[existingElementIdx].value += current.value;
      return chartDataAcc;
    } else {
      chartDataAcc.push(current);
      return chartDataAcc;
    }
  }, []);
  return filteredData;
};

const BarGraph = ({ data, key, targetValue, average }) => {
  const mappedData = data.map((data, idx) => mapData(data, targetValue, idx));
  const chartData = removeRepeated(mappedData);
  console.log("chartData==", chartData);
  return (
    <div className="nutrition-summary-graph">
      <ResponsiveContainer width="100%">
        <ComposedChart data={chartData} key={key} margin={{ left: -20 }}>
          <CartesianGrid
            horizontal={true}
            vertical={false}
            stroke="#424242"
            strokeDasharray="5 5"
            strokeWidth={1}
          />
          <XAxis
            dataKey="date"
            scale="point"
            tickFormatter={(tick) => {
              if (
                tick === chartData[0].date ||
                tick === chartData[chartData.length - 1].date
              ) {
                return tick;
              } else return "";
            }}
            tick={{ fill: "var(--white)", fontSize: "0.75rem" }}
          />
          <YAxis
            axisLine={false}
            tickFormatter={(tick) => `${Math.round(tick / 1000)}k`}
            tick={{ fill: "var(--white)", fontSize: "0.75rem" }}
            dx={-10}
          />
          <Bar
            name="Steps"
            dataKey="value"
            fill="var(--gradient-left)"
            barSize={20}
          />
          <ReferenceLine
            stroke="var(--white)"
            strokeDasharray="5 5"
            strokeWidth={2}
            y={average}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BarGraph;
